/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import { MODELS_NAME } from '../../../Apis/Models';
import { ACTION_MODEL } from '../../../Helpers/ActionModel';
import { permissionObj } from '../../../Helpers/permission';
import routes from "../../../Routes/routes";
import HeadTittle from "../../../components/HeadTittle";
import StepTab from "../../../components/StepperTabs/StepTab";
import StepperTabs from "../../../components/StepperTabs/StepperTabs";
import ButtonAction from "../../../components/buttons/ButtonAction";
import ExportDataBtn from '../../../components/buttons/ExportDataBtn';
import { AddIcon, EditIcon, TrashOutlineIcon } from "../../../components/buttons/IconButtons";
import ImportDataBtn from "../../../components/buttons/ImportDataBtn";
import SearchFilterBtn from '../../../components/buttons/SearchFilterBtn';
import ImportFileModal from '../../Modals/ImportFileModal';
import SearchFor from '../../Modals/SearchFor';
import ContractorPanelApp from "./Functionality/ContractorPanelApp";
import { TAB_PERMISSION_CONTRACTORS, TABS_CONTRACTORS } from './Model/Models';
import ContractTab from "./SubComponents/ContractTab/ContractTab";
import ContractorsTab from "./SubComponents/ContractorTab/ContractorsTab";
import DocumentationView from './SubComponents/Documentation/DocumentationView';
import ManageContractors from './SubComponents/ManageContractors/ManageContractors';
import DeleteModal from "../../Modals/DeleteModal";
import React from "react";
import {USER_TYPE_MODEL} from '../../../enums/userTypeEnum';
import {fieldModelKeyName} from "../../../enums/fieldModelEnum";


const ContractorPanel = () => {
    const {
        t, // Translation function for text localization
        navigate,
        DEV,
        permission,
        steps,
        contractorId,
        view,
        setView,
        search,
        option,
        finalArray,
        activeStep,
        setActiveStep,
        setDeleteContractShow,
        criteria,
        setCriteria,
        bodyForExport,
        setBodyForExport,
        searchElement,
        setSearchElement,
        setSearch,
        setSimpleSearch,
        supplierId,
        modified,
        setModified,
        deleteContractShow,
        deleteContractorShow,
        setDeleteContractorShow,
        filterDialogShow,
        setFilterDialogShow,
        moduleId,
        importFileShow,
        setImportFileShow,
        setCreationErrorsShow,
        setLoaded,
        isAllChecked,
        setIsAllChecked,
        isAllCheckedContractor,
        setIsAllCheckedContractor,
        selectContractForDelete,
        setSelectContractForDelete,
        selectContractorForDelete,
        setSelectContractorForDelete,
        selectApprovalFlowForDelete,
        setSelectApprovalFlowForDelete,
        setFinalArray,
        handleStepChange,
        deleteSelectedContracts,
        deleteSelectedContractors,
        subView,
        handleSubViewChange,
        handleDelete,
        btnUpdateRef,
        deleteApprovalFlowShow,
        setDeleteApprovalFlowShow,
        handleCreate,
        viewType,
        userTypeId
    } = ContractorPanelApp();

    if (!DEV && !permission?.includes(permissionObj.WEB_CONTRACTOR_READ)
        && !permission?.includes(permissionObj.WEB_CONTRACTOR_CONTRACT_READ)
        && !permission?.includes(permissionObj.WEB_CONTRACTOR_APPROVAL_FLOW_READ)
        && !permission?.includes(permissionObj.WEB_CONTRACTOR_MANAGE_READ)
        && !permission?.includes(permissionObj.WEB_CONTRACTOR_REQUEST_READ)
        && contractorId === null) navigate(routes.forbidden);

    return (
        <>
            <HeadTittle  name={contractorId === null ? t('contractors') : t('contracts')}>

                {TAB_PERMISSION_CONTRACTORS(subView, contractorId, permission, DEV)[ACTION_MODEL.IMPORT][activeStep] && (
                    <ImportDataBtn id="btn_ct_import" onClickFn={() => setImportFileShow(true)} />
                )}

                {TAB_PERMISSION_CONTRACTORS(subView, contractorId, permission, DEV)[ACTION_MODEL.EXPORT][activeStep] && (
                    search ? (
                        <ExportDataBtn
                            id={"btn_cp_export"}
                            body={criteria}
                            search={search}
                            option={option}
                            moduleId={moduleId}
                        />
                    ) : (
                        <ExportDataBtn
                            id={"btn_cp_export"}
                            search={search}
                            option={option}
                            body={bodyForExport}
                            moduleId={moduleId}
                        />
                    )
                )}

                {TAB_PERMISSION_CONTRACTORS(subView, contractorId, permission, DEV)[ACTION_MODEL.CREATE][activeStep] && (
                    <ButtonAction
                        id="btn_cp_create"
                        name="create"
                        className="btn-icon-add"
                        Icon={AddIcon}
                        onClick={() => handleCreate(activeStep)}
                    />
                )}

                {TAB_PERMISSION_CONTRACTORS(subView, contractorId, permission, DEV)[ACTION_MODEL.DELETE][activeStep] && (
                    <ButtonAction
                        id="btn_cp_delete"
                        name="delete"
                        className="btn-icon-delete"
                        disabled={
                            (selectContractForDelete?.length === 0 && activeStep === TABS_CONTRACTORS.CONTRACTS.INDEX) ||
                            (selectContractorForDelete?.length === 0 && activeStep === TABS_CONTRACTORS.CONTRACTORS.INDEX) ||
                            (selectApprovalFlowForDelete?.length === 0 && activeStep === TABS_CONTRACTORS.DOCUMENTATION.INDEX)
                        }
                        Icon={TrashOutlineIcon}
                        onClick={() => handleDelete(activeStep)}
                    />
                )}

                {TAB_PERMISSION_CONTRACTORS(subView, contractorId, permission, DEV)[ACTION_MODEL.UPDATE][activeStep] && (
                    <ButtonAction
                        id="btn_cp_update_data"
                        className="btn-icon-edit"
                        Icon={EditIcon}
                        name="update"
                        onClick={()=>{
                            if(activeStep === TABS_CONTRACTORS.MANAGE.INDEX )
                                btnUpdateRef.current?.handleUpdate();
                        }}
                    />
                )}

                {TAB_PERMISSION_CONTRACTORS(subView, contractorId, permission, DEV)[ACTION_MODEL.ADVANCE_SEARCH][activeStep] && (
                    <SearchFilterBtn finalArray={finalArray} fnclick={() => setFilterDialogShow(true)} />
                )}
            </HeadTittle>
            <StepperTabs
                onlyTab={true}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => { }}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={TABS_CONTRACTORS.CONTRACTS.INDEX} activeStep={activeStep} view={view}>
                    {activeStep === TABS_CONTRACTORS.CONTRACTS.INDEX && (
                        <ContractTab
                            t={t}
                            contractorId={contractorId}
                            supplierId={supplierId}
                            view={view}
                            setView={setView}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            option={option}
                            search={search}
                            setSearch={setSearch}
                            setSimpleSearch={setSimpleSearch}
                            selectedList={selectContractForDelete}
                            setSelectedList={setSelectContractForDelete}
                            setDeleteContractShow={setDeleteContractShow}
                            isAllChecked={isAllChecked}
                            setIsAllChecked={setIsAllChecked}
                            modified={modified}
                            setModified={setModified}
                            bodyForExport={bodyForExport}
                            setBodyForExport={setBodyForExport}
                        />
                    )}
                </StepTab>

                <StepTab index={TABS_CONTRACTORS.CONTRACTORS.INDEX} activeStep={activeStep}>
                    {activeStep === TABS_CONTRACTORS.CONTRACTORS.INDEX && (
                        <>
                            <ContractorsTab
                                view={view}
                                setView={setView}
                                contractorId={contractorId}
                                supplierId={supplierId}
                                searchElement={searchElement}
                                setSearchElement={setSearchElement}
                                search={search}
                                setSearch={setSearch}
                                setSimpleSearch={setSimpleSearch}
                                criteria={criteria}
                                setCriteria={setCriteria}
                                finalArray={finalArray}
                                setImportFileShow={setImportFileShow}
                                setDeleteContractorShow={setDeleteContractorShow}
                                isAllCheckedContractor={isAllCheckedContractor}
                                setIsAllCheckedContractor={setIsAllCheckedContractor}
                                selectedList={selectContractorForDelete}
                                setSelectedList={setSelectContractorForDelete}
                                setFilterDialogShow={setFilterDialogShow}
                                modified={modified}
                                setModified={setModified}
                                bodyForExport={bodyForExport}
                                setBodyForExport={setBodyForExport}
                            />
                        </>
                    )}
                </StepTab>
                <StepTab index={TABS_CONTRACTORS.MANAGE.INDEX} activeStep={activeStep}>
                    {activeStep === TABS_CONTRACTORS.MANAGE.INDEX && (
                        <div>
                            <ManageContractors
                                ref={btnUpdateRef}
                                userType={USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE}
                            />
                        </div>
                    )}
                </StepTab>
                <StepTab index={TABS_CONTRACTORS.DOCUMENTATION.INDEX} activeStep={activeStep}>
                    {activeStep === TABS_CONTRACTORS.DOCUMENTATION.INDEX && (
                        <>
                            <DocumentationView
                                subView={subView}
                                handleSubViewChange={handleSubViewChange}
                                DEV={DEV}
                                option={option}
                                permission={permission}
                                searchElement={searchElement}
                                setSearchElement={setSearchElement}
                                setApprovalFlowShow={setDeleteApprovalFlowShow}
                                deleteApprovalFlowShow={deleteApprovalFlowShow}
                                setIsAllChecked={setIsAllChecked}
                                setDeleteApprovalFlowShow={setDeleteApprovalFlowShow}
                                selectedList={selectApprovalFlowForDelete}
                                setSelectedList={setSelectApprovalFlowForDelete}
                                search={search}
                                setSearch={setSearch}
                                setSimpleSearch={setSimpleSearch}
                                viewType={viewType}
                                userTypeId={userTypeId}
                            />
                        </>
                    )}
                </StepTab>

            </StepperTabs>

            { deleteContractShow &&
                <DeleteModal
                    show={deleteContractShow}
                    onHide={() => setDeleteContractShow(false)}
                    onClickFn={() => deleteSelectedContracts(selectContractForDelete)}
                    data={selectContractForDelete}
                    title_modal={t('delete')}
                    description={'are_you_sure_you_want_to_delete'}
                    element_modal={t('contracts')}
                />
            }

            { deleteContractorShow &&
                <DeleteModal
                    show={deleteContractorShow}
                    onHide={() => setDeleteContractorShow(false)}
                    onClickFn={() => deleteSelectedContractors(selectContractorForDelete)}
                    data={selectContractorForDelete}
                    title_modal={t('delete')}
                    description={'are_you_sure_you_want_to_delete'}
                    element_modal={t('contractors')}
                />
            }

            {(filterDialogShow || finalArray?.length > 0) &&
                <SearchFor
                    open={filterDialogShow}
                    onClose={() => {
                        setFilterDialogShow(false);
                    }}
                    onFiltered={(originalArray) => {
                        setFilterDialogShow(false);
                        setFinalArray(originalArray);
                        setSearchElement(''); // Clear search input after filtering
                    }}
                    moduleId={moduleId}
                    option={option}
                    finalArray={finalArray}
                    search={search}
                    setSearch={setSearch}
                    cleanAdvance={modified}
                    setCleanAdvance={setModified}
                    setFinalArray={setFinalArray} // Used to reset filters
                    searchElement={searchElement} // Track input changes
                    noShowFilters={[fieldModelKeyName.secondLastNameContractor]}
                />
            }
            <ImportFileModal
                show={importFileShow}
                onHide={() => setImportFileShow(false)}
                onCreationErrors={() => setCreationErrorsShow(true)}
                onCreated={() => {
                    setLoaded(true);
                    setModified(true);
                }}
                title_modal={t('import')}
                element_modal={t('contractors')}
                model={MODELS_NAME.contractor}
            />
        </>
    );
};
export default ContractorPanel;
